import { render } from "./HomePageTwo.vue?vue&type=template&id=13cf8815"
import script from "./HomePageTwo.vue?vue&type=script&lang=js"
export * from "./HomePageTwo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__